import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { GOOGLE_API_KEY } from '../../../config';

import { AreaDrawManager, BranchMarker, DeliveryAreas } from './map-components';

import { compose, withProps, withStateHandlers, lifecycle } from 'recompose';
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps';


const CustomMapComponent = compose(
    withStateHandlers(() => ({
    }), {
        }),
    withProps({
        googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&v=3.64&libraries=geometry,drawing,places`,
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap,
    lifecycle({})
)((props) => {
    if (!props.restaurant.lat && !props.restaurant.lng) return null;

    return (
        <GoogleMap
            defaultZoom={15}
            defaultCenter={{ lat: props.restaurant.lat, lng: props.restaurant.lng }}>
            <AreaDrawManager
                addNewDraftDeliveryArea={props.addNewDraftDeliveryArea}
                removeDraftDeliveryArea={props.removeDraftDeliveryArea}
                 />
            <BranchMarker
                restaurant={props.restaurant}
                position={{ lat: props.restaurant.lat, lng: props.restaurant.lng }}
                 />
            <DeliveryAreas
                restaurant={props.restaurant}
                areasStatus={props.areasStatus}
                generatedDeliveryAreas={props.generatedDeliveryAreas}
                updateDeliveryAreaEdit={props.updateDeliveryAreaEdit}
                 />
        </GoogleMap>
    );
});

class DeliveryMap extends Component {
    state = {
    };

    render() {
        const {
            restaurant,
            addNewDraftDeliveryArea,
            removeDraftDeliveryArea,
            areasStatus,
            updateDeliveryAreaEdit,
            generatedDeliveryAreas
        } = this.props;

        return (
            <CustomMapComponent
                restaurant={restaurant}
                addNewDraftDeliveryArea={addNewDraftDeliveryArea}
                removeDraftDeliveryArea={removeDraftDeliveryArea}
                areasStatus={areasStatus}
                updateDeliveryAreaEdit={updateDeliveryAreaEdit}
                generatedDeliveryAreas={generatedDeliveryAreas}
               
            />
        );
    }
}

DeliveryMap.propTypes = {
    restaurant: PropTypes.object,
    areasStatus: PropTypes.object,
    generatedDeliveryAreas: PropTypes.array,

    addNewDraftDeliveryArea: PropTypes.func,
    removeDraftDeliveryArea: PropTypes.func,
    
    updateDeliveryAreaEdit: PropTypes.func,
    
    
};

export default DeliveryMap;
